Pegasus.ApplicationView = Ember.View.extend({
  templateName: 'application',
  classNames: ['vr-application'],

  classNameBindings: [
    'status',
    'subStatus',
    'documentsLoaded:documents-loaded:documents-loading'
  ],

  documentsLoadedBinding: 'controller.documentsLoaded',

  status: function(){
    return Pegasus.get('status');
  }.property('Pegasus.status'),

  subStatus: function(){
    return Pegasus.get('subStatus');
  }.property('Pegasus.subStatus'),

  scrollPane: function(){
    return this.$('.center-panel');
  }.property().volatile(),

  scrollContent: function(){
    return this.$('.center-wrapper');
  }.property().volatile(),

  adjustedHeight: function(){
    return this.get('scrollPane').height() - this.$('.subject').height();
  }.property().volatile(),

  didInsertElement: function(){
    this._super();
    this.catchKeys();
  },

  filteredKeys: [8,46],

  shouldKeyFilter: function(code){
    if ( code === 27 ) {
      this.get('controller').send('escape');
    }
    return this.filteredKeys.contains(code) &&
      !$('input, textarea, [contenteditable]').is(':focus');
  },

  catchKeys: function(){
    $(window).keydown(function(e) {
      var keyFilter = this.shouldKeyFilter(e.keyCode);
      if(keyFilter) {
        e.preventDefault();
        e.stopPropagation();
        return;
      }

      if ( e.keyCode === 33 ) {
        $('.center-wrapper-container').scrollTo(0);
        return false;
      }
      if ( e.keyCode === 34 ) {
        $('.center-wrapper-container').scrollTo(
          $('.center-wrapper').height()
        );
        return false;
      }

    }.bind(this));
  }
});
